import React from "react";
import { useDeleteConfirmation } from "./DeleteConfirmationModalContext";

import { DeleteArchiveConfirmationTooltipButton } from "./DeleteConfirmationTooltipButton";

const DeleteConfirmationTooltip = () => {
  const { closeDialog, confirmDelete, popupState } = useDeleteConfirmation();

  return (
    <DeleteArchiveConfirmationTooltipButton
      closeDialog={closeDialog}
      confirmAction={confirmDelete}
      popupState={popupState}
      deleteItem={true}
    />
  );
};

export default DeleteConfirmationTooltip;
